import React, { useEffect, useState } from "react";
import styles from "./HomePage.module.css";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageContainer from "../components/pages/PageContainer";
import PageHeader from "../components/PageHeader";
import { Link } from "react-router-dom";
import { getVibeBadge } from "../api/vibe";
import { useTranslation } from "react-i18next";
import CustomPageHeader from "../components/pages/CustomPageHeader";

const HomePage = () => {
  const [sentCount, setSentCount] = useState(0);
  const [receivedCount, setReceivedCount] = useState(0);
  const [useAlternativeLayout, setUseAlternativeLayout] = useState(true);
  const { t } = useTranslation();

  const nodes = [
    {
      label: t("profile"),
      icon: <img src="profile.png" alt="Profile" className={styles.nodeIcon} />,
      color: "#7c3aed",
      link: "/profile",
      gridArea: "top",
    },
    {
      label: t("my_links"),
      icon: <img src="group.png" alt="My Links" className={styles.nodeIcon} />,
      color: "#3b82f6",
      link: "/my-links",
      gridArea: "right",
    },
    {
      label: t("vibes"),
      icon: <img src="zero.png" alt="Vibes" className={styles.nodeIcon} />,
      color: "#a21caf",
      link: "/my-vibes",
      badge: 0,
      gridArea: "left",
      number: 0,
    },
    {
      label: t("vibe_bucks"),
      icon: <img src="dollar.png" alt="Vibe Bucks" className={styles.nodeIcon} />,
      color: "#059669",
      link: "/vibes-bucks",
      gridArea: "bottom",
    },
    {
      label: t("calendar"),
      icon: <img src="calender.png" alt="Calendar" className={styles.nodeIcon} />,
      color: "#14b8a6",
      link: "/calendar",
      gridArea: "centerRight",
    },

    {
      label: t("start_vibe"),
      icon: <img src="logo-bg.png" alt="Start Vibe" className={styles.startVibeIcon} />,
      color: "#14b8a6",
      link: "/create-vibe",
      gridArea: "centerRight",
    },
  ];

  useEffect(() => {
    async function fetchCounts() {
      try {
        const res = await getVibeBadge();
        setSentCount(Number(res?.data?.send_vibe_count || 0));
        setReceivedCount(Number(res?.data?.receive_vibe_count || 0));
      } catch (err) {
        setSentCount(0);
        setReceivedCount(0);
      }
    }
    fetchCounts();
  }, []);

  // Update nodes array with counts
  nodes[2].number = receivedCount;
  nodes[2].badge = receivedCount;

  return (
    <>
      <CustomPageHeader
        hideBack={true}
        showPageHeader={false}
        pageContainerClass="px-2 w-full mx-auto max-w-4xl"
        title={t("app_name", "Vibelinks")}
      >
        <div className="">
         
          
          {useAlternativeLayout ? (
            <div className={styles.alternativeLayout}>

<div className="pb-2 mx-auto w-full flex justify-center">
            <img src="image (27).png" alt="VIBELINKS" className="h-8 object-contain" />
          </div>
              {/* VibeLinks Logo */}
              <div className={styles.vibeLinksLogo}>
                <img 
                  src="logo-bg.png"
                  alt="VibeLinks" 
                  className={styles.logoImage} 
                />
              </div>
              
              {/* Central Start Vibe Button */}
              <div className={styles.centralStartVibe}>
                <Link 
                  to={nodes[5].link} 
                  className={styles.startVibeButton}
                  style={{
                    backgroundImage: 'url(button_vibenew.png)'
                  }}
                >
                  {t("start_vibe", "")}
                </Link>
              </div>
              
              {/* Grid of icons */}
              <div className={styles.iconGrid}>
                {/* First Row */}
                <div className={styles.gridRow}>
                  <div className={styles.gridItem}>
                    <Link to={nodes[0].link} className={styles.gridItemLink}>
                      <div className={styles.gridItemContent}>
                        {nodes[0].icon}
                        <span className={styles.gridItemLabel}>{nodes[0].label}</span>
                      </div>
                    </Link>
                  </div>
                  <div className={styles.gridItem}>
                    <Link to={nodes[1].link} className={styles.gridItemLink}>
                      <div className={styles.gridItemContent}>
                        {nodes[1].icon}
                        <span className={styles.gridItemLabel}>{nodes[1].label}</span>
                      </div>
                    </Link>
                  </div>
                  <div className={styles.gridItem}>
                    <Link to={nodes[2].link} className={styles.gridItemLink}>
                      <div className={styles.gridItemContent}>
                        {/* {receivedCount > 0 && <span className={styles.gridBadge}>{receivedCount}</span>} */}
                        <span className={styles.gridItemText}>{nodes[2].number}</span>
                        <span className={styles.gridItemLabel}>{nodes[2].label}</span>
                      </div>
                    </Link>
                  </div>
                </div>
                
                {/* Second Row */}
                <div className={styles.gridRow}>
                  <div className={styles.gridItem}>
                    <Link to={nodes[4].link} className={styles.gridItemLink}>
                      <div className={styles.gridItemContent}>
                        {nodes[4].icon}
                        <span className={styles.gridItemLabel}>{nodes[4].label}</span>
                      </div>
                    </Link>
                  </div>
                  <div className={styles.gridItem}>
                    <Link to="/notifications" className={styles.gridItemLink}>
                      <div className={styles.gridItemContent}>
                        <img src="notification.png" alt="Notifications" className={styles.nodeIcon} />
                        <span className={styles.gridItemLabel}>{t("notifications")}</span>
                      </div>
                    </Link>
                  </div>
                  <div className={styles.gridItem}>
                    <Link to={nodes[3].link} className={styles.gridItemLink}>
                      <div className={styles.gridItemContent}>
                        {nodes[3].icon}
                        <span className={styles.gridItemLabel}>{nodes[3].label}</span>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              
              {/* Settings Icon */}
              <div className={styles.settingsIcon}>
                <Link to="/settings" className={styles.settingsLink}>
                  <img src="setting_vibe_.png" alt="Settings" className={styles.settingsIconImg} />
                </Link>
              </div>
            </div>
          ) : (
            <div className={styles.homeContainer}>
              <div className={styles.mainGrid}>
              {/* Profile node */}
              <div className={`${styles.nodeCol} ${styles.profileNode}`}>
                <div className={styles.nodeCircle}>
                  <Link to={nodes[0].link}>{nodes[0].icon}</Link>
                </div>
                <div className={styles.nodeLabel}>{nodes[0].label}</div>
              </div>
              {/* My Links node */}
              <div className={`${styles.nodeCol} ${styles.myLinksNode}`}>
                <div className={styles.nodeCircle}>
                  <Link to={nodes[1].link}>{nodes[1].icon}</Link>
                </div>
                <div className={styles.nodeLabel}>{nodes[1].label}</div>
              </div>
              {/* Vibes node */}
              <div className={`${styles.nodeCol} ${styles.vibesNode}`}>
                <Link to={nodes[2].link}>
                  <div className={styles.nodeCircle}>
                    {nodes[2].badge > 0 && <span className={styles.badge}>{nodes[2].badge}</span>}
                    <span
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#a21caf",
                        fontWeight: 700,
                        fontSize: 16,
                      }}
                    >
                      {nodes[2].number}
                    </span>
                  </div>
                </Link>
                <div className={styles.nodeLabel}>{nodes[2].label}</div>
              </div>
              {/* Vibe Bucks node */}
              <div className={`${styles.nodeCol} ${styles.vibeBucksNode}`}>
                <div className={styles.nodeCircle}>
                  <Link to={nodes[3].link}>{nodes[3].icon}</Link>
                </div>
                <div className={styles.nodeLabel}>{nodes[3].label}</div>
              </div>
              {/* Calendar node */}
              <div className={`${styles.nodeCol} ${styles.calendarNode}`}>
                <div className={styles.nodeCircle}>
                  <Link to={nodes[4].link}>{nodes[4].icon}</Link>
                </div>
                <div className={styles.nodeLabel}>{nodes[4].label}</div>
              </div>
              {/* Central node */}
              <div className={styles.centralNode}>
                <Link to={nodes[5].link}>{nodes[5].icon}</Link>
              </div>
              <div className={styles.centralLabel}>
                {t("start_vibe", "Start Vibe")}
              </div>
            </div>
            </div>
          )}
        </div>
      </CustomPageHeader>
    </>
  );
};

export default HomePage;
